import { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import Nav from "./nav";
import Footer from "./Footer";

const Page = () => {


    const [data, setData] = useState("");
    const [index, setIndex] = useState(0);
    const [PageName, setPage] = useState("");

    /*  const location = useLocation();
     const urldata=(location.pathname).split('/');  
     console.log(urldata[2]); */


    useEffect(() => {
        const currentURL = window.location.href;
        const pageName = (currentURL).split('/');
        setPage(pageName[3]);

        const url = "https://sbvmapi.uniservedata.in/api/content?pageName=" + pageName[3];
        GetData(url, pageName[4]);


    }, []);

    const searchJSON = (ApiData, id) => {
      //  console.log(ApiData);
        var indexid;
        ApiData.content_data.map((m, i) => {
          //  console.log(m.heading);
            if (m._id == (id)) {
                indexid = i;
                return i;
            } else {
                return null; // or any other value that represents no match
            }
        });
        return indexid;
    }

    const GetData = async (url, page) => {
        const data2 = await fetch(url);
        const res = await data2.json();

        if (page === undefined) { } else {                             // console.log(res.content_data);
            const id = searchJSON(res, page);
           // console.log(id);
            Getid(id);
        }
        setData(res.content_data);
    }

    const getImg = (url) => {
        const parts = url.split("\/");
        const newurl = "https://sbvmapi.uniservedata.in/image/" + parts[1];
        // console.log(newurl);
        return newurl;
    }

    const Getid = (id) => {
        setIndex(id);
    }

    return (
        <>
            <Nav></Nav>
            <div className="news_section layout_padding" style={{ marginBottom: "2em", backgroundColor: "#F3F4F6", padding: "2rem 0" }}>
  <div className="container">
    <h1 style={{ color: "rgb(183, 110, 121)", textAlign: "center", fontWeight: "bold" }}>{PageName}</h1>
    <hr style={{ height: '3px', backgroundColor: 'rgb(183, 110, 121)', width: '18%', margin: '14px auto 30px', border: 'none' }} />

    <div className="row">

      <div className="gutter col-lg-8 col-md-8" style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)" }}>
        {data.length > 0 ? (
          <>
            {data[index].img && (
              <div className="image-container" style={{ marginBottom: "20px", textAlign: "center" }}>
                <img src={getImg(data[index].img)} alt="about-section" style={{ maxWidth: "100%", borderRadius: "10px", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }} />
              </div>
            )}

            <h2 style={{ color: "rgb(183, 110, 121)", fontWeight: "bold" }}>{data[index].heading}</h2>
            <hr style={{ height: '2px', backgroundColor: 'rgb(183, 110, 121)', width: '28%', margin: '14px 0 17px', border: 'none' }} />

            <p dangerouslySetInnerHTML={{ __html: data[index].textData }} style={{ color: "#333", fontSize: "16px", lineHeight: "1.6" }}></p>
          </>
        ) : null}
      </div>

      <div className="vr d-none d-lg-block"></div>

      <div className="gutter col-lg-4 col-md-4 quicklink" style={{ borderLeft: "2px solid #E5E7EB", paddingLeft: "20px", marginTop: "1rem" }}>
        <h2 style={{ color: "rgb(183, 110, 121)", fontWeight: "bold" }}>Quick Links</h2>
        <hr style={{ height: '2px', backgroundColor: 'rgb(183, 110, 121)', width: '40%', margin: '14px 0 20px', border: 'none' }} />

        {data.length > 0 && data.map((i, m) => (
          i.nameType !== "What We Do" && (
            <p
              key={m}
              className={`text quicklink-item ${index === m ? 'active' : ''}`}
              onClick={() => Getid(m)}
              style={{
                cursor: "pointer",
                color: index === m ? "#F59E0B" : "rgb(183, 110, 121)",
                padding: "8px 0",
                fontWeight: "500",
                transition: "all 0.3s ease",
                transform: index === m ? "translateX(5px)" : "translateX(0)"
              }}
              onMouseOver={(e) => {
                e.target.style.color = '#F59E0B';
                e.target.style.transform = 'translateX(5px)';
              }}
              onMouseOut={(e) => {
                if (index !== m) {
                  e.target.style.color = 'rgb(183, 110, 121)';
                  e.target.style.transform = 'translateX(0)';
                }
              }}
            >
              {i.heading}
            </p>
          )
        ))}
      </div>
    </div>
  </div>
</div>



            <Footer ></Footer>
        </>
    );
}

export default Page;